import styled from 'styled-components';

export const SError = styled.div`
    margin-top: 5px;
    color: ${({ theme }) => theme.color.error.main};
    font-size: 1.2rem;
    font-weight: bold;
`;
